import { Injectable } from '@angular/core';
import { ServiceCenterAsset } from './models/service-center-asset';
import { ScSnapshotStore } from './sc-snapshot-store';

@Injectable({ providedIn: 'root' })
export class AssetCacheStoreService extends ScSnapshotStore<ServiceCenterAsset> {
  protected readonly dbName = 'fleethd-sc';
  protected readonly storeName = 'records';
  // Bump when a cached field's meaning changes, not only its shape.
  protected readonly schemaVersion = 3;
}
